<template>
  <div class="column is-12">
    <p class="has-text-grey is-size-7 mb-3">* Todo los campos son requeridos</p>
    <form id="form-checkout">
      <input type="hidden" name="MPHiddenInputToken" />
      <div class="columns is-multiline">
        <div class="column is-12">
          <div class="field">
            <div class="columns">
              <div class="column is-6">
                <div class="field has-addons">
                  <div class="control">
                    <input
                      class="input"
                      type="text"
                      name="cardNumber"
                      id="form-checkout__cardNumber"
                    />
                  </div>
                  <div class="control has-icons-left">
                    <div class="select">
                      <select name="issuer" id="form-checkout__issuer"></select>
                    </div>
                    <div class="icon is-small is-left">
                      <i class="fas fa-university"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="column is-6">
                <div class="field has-addons">
                  <div class="control">
                    <input
                      class="input"
                      type="text"
                      name="cardExpirationMonth"
                      id="form-checkout__cardExpirationMonth"
                    />
                  </div>
                  <div class="control">
                    <input
                      class="input"
                      type="text"
                      name="cardExpirationYear"
                      id="form-checkout__cardExpirationYear"
                    />
                  </div>
                  <div class="control">
                    <input
                      class="input"
                      type="text"
                      name="securityCode"
                      id="form-checkout__securityCode"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="field">
            <div class="columns">
              <div class="column is-6">
                <div class="field">
                  <div class="control">
                    <input
                      class="input"
                      type="text"
                      name="cardholderName"
                      id="form-checkout__cardholderName"
                    />
                  </div>
                </div>
              </div>
              <div class="column is-6">
                <div class="field">
                  <div class="control">
                    <input
                      class="input"
                      type="email"
                      name="cardholderEmail"
                      id="form-checkout__cardholderEmail"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="field has-addons">
            <div class="control has-icons-left">
              <div class="select">
                <select
                  name="identificationType"
                  id="form-checkout__identificationType"
                ></select>
              </div>
              <div class="icon is-small is-left">
                <i class="fas fa-id-card"></i>
              </div>
            </div>
            <div class="control">
              <input
                class="input"
                type="text"
                name="identificationNumber"
                id="form-checkout__identificationNumber"
              />
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <div class="select">
              <select
                name="installments"
                id="form-checkout__installments"
              ></select>
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="field">
            <div class="control">
              <button
                class="button btn is-fullwidth mb-3"
                type="submit"
                id="form-checkout__submit"
              >
                Pagar
              </button>
            </div>
            <progress value="0" class="progress">Cargando...</progress>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "FormCreditCard",
  mounted() {
    const mp = new MercadoPago("TEST-e78441e0-28b7-4523-865e-59e69eb63e2f", {
      locale: "es-CO",
    });
    this.getMercadoPago(mp);
  },
  methods: {
    getMercadoPago(mp) {
      const cardForm = mp.cardForm({
        amount: "0",
        autoMount: true,
        processingMode: "aggregator",
        form: {
          id: "form-checkout",
          cardholderName: {
            id: "form-checkout__cardholderName",
            placeholder: "Nombre",
          },
          cardholderEmail: {
            id: "form-checkout__cardholderEmail",
            placeholder: "Email",
          },
          cardNumber: {
            id: "form-checkout__cardNumber",
            placeholder: "Numero de la targeta",
          },
          cardExpirationMonth: {
            id: "form-checkout__cardExpirationMonth",
            placeholder: "MM",
          },
          cardExpirationYear: {
            id: "form-checkout__cardExpirationYear",
            placeholder: "YYYY",
          },
          securityCode: {
            id: "form-checkout__securityCode",
            placeholder: "CVV",
          },
          installments: {
            id: "form-checkout__installments",
            placeholder: "Cuotas",
          },
          identificationType: {
            id: "form-checkout__identificationType",
            placeholder: "Tipo de documento",
          },
          identificationNumber: {
            id: "form-checkout__identificationNumber",
            placeholder: "DNI",
          },
          issuer: {
            id: "form-checkout__issuer",
            placeholder: "Banco",
          },
        },
        callbacks: {
          onFormMounted: (error) => {
            if (error)
              return console.warn("Form Mounted handling error: ", error);
            console.log("Form mounted");
          },
          onFormUnmounted: (error) => {
            if (error)
              return console.warn("Form Unmounted handling error: ", error);
            console.log("Form unmounted");
          },
          onIdentificationTypesReceived: (error, identificationTypes) => {
            if (error)
              return console.warn(
                "identificationTypes handling error: ",
                error
              );
            console.log(
              "Identification types available: ",
              identificationTypes
            );
          },
          onPaymentMethodsReceived: (error, paymentMethods) => {
            if (error)
              return console.warn("paymentMethods handling error: ", error);
            console.log("Payment Methods available: ", paymentMethods);
          },
          onIssuersReceived: (error, issuers) => {
            if (error) return console.warn("issuers handling error: ", error);
            console.log("Issuers available: ", issuers);
          },
          onInstallmentsReceived: (error, installments) => {
            if (error)
              return console.warn("installments handling error: ", error);
            console.log("Installments available: ", installments);
          },
          onCardTokenReceived: (error, token) => {
            if (error) return console.warn("Token handling error: ", error);
            console.log("Token available: ", token);
          },
          onSubmit: (event) => {
            event.preventDefault();
            const cardData = cardForm.getCardFormData();
            this.$emit("mercadoPagoTokenHandler", cardData);
            console.log("CardForm data available: ", cardData);
          },
          onFetching: (resource) => {
            console.log("Fetching resource: ", resource);

            // Animate progress bar
            const progressBar = document.querySelector(".progress");
            progressBar.removeAttribute("value");

            return () => {
              progressBar.setAttribute("value", "0");
            };
          },
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  color: #745192;
  width: 100%;
  margin-bottom: 1rem;
  background-color: #fff;
  border: #745192 solid 1px;
  transition: all linear 0.1s;
  &:hover {
    background-color: #745192;
    color: #fff;
  }
}
</style>